import alt from '../alt';
import CurrentUserActions from '../actions/CurrentUserActions';
import SingleObjectResource from '../resources/GenericResource';


class CompanyActions {
    constructor() {
        this.generateActions('getCompanySuccess', 'mergeErrorsIntoState', 'clearCompanyData');
    }

    updateCompany(company) {
        new SingleObjectResource(DJ_CONST.API.myCompany).patch({}, company).then(result => {
            this.dispatch(company);
        }).catch(err => this.actions.failUpdateCompany(err));
    }

    failUpdateCompany(updateError) {
        if (updateError.statusCode === 400){
            this.dispatch({updateError});
        } else {
            return CurrentUserActions.pageFault(updateError);
        }
    }
}

export default alt.createActions(CompanyActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/CompanyActions.js
 **/